import {
  REQUEST_MTUS_FOR_CURRENT_PERIOD,
  REQUEST_MTUS_FOR_CURRENT_PERIOD_ERROR,
  RECEIVE_MTUS_FOR_CURRENT_PERIOD
} from 'actions'

const initialState = {
  data: {}
}

export default function (state = initialState, action) {
  const { type, payload } = action

  switch (type) {
    case REQUEST_MTUS_FOR_CURRENT_PERIOD:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.workspaceSlug]: {
            ...state.data[payload.workspaceSlug],
            isRequesting: true
          }
        }
      }
    case RECEIVE_MTUS_FOR_CURRENT_PERIOD:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.workspaceSlug]: {
            ...state.data[payload.workspaceSlug],
            isRequesting: false,
            data: payload.data
          }
        }
      }
    case REQUEST_MTUS_FOR_CURRENT_PERIOD_ERROR:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.workspaceSlug]: {
            ...state.data[payload.workspaceSlug],
            isRequesting: false,
            error: payload.error
          }
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/mtus/current-period.js